import { PHONE_PATTERN } from "../const/Patterns"
import { trackInvalidEnquiryForm } from "../shared/helpers/gtm_tracking"

const handleBlur = e => {
  const { target: input } = e;

  if (input.matches(".js-trim-email")) {
    input.value = input.value.replace(/\s/g, "");
  }
};

const handleFocus = e => {
  const { target: input } = e;

  if (input.matches(".form-control")) {
    input.classList.remove("is-invalid");
  }
};

const handleInput = e => {
  const { target: input } = e;

  if (input.matches(".js-floating-placeholder")) {
    input.parentElement.classList.toggle("has-input", !!input.value);
  }
};

const handleInvalid = e => {
  const { target: input } = e;

  if (input.matches(".form-control")) {
    e.preventDefault();
    input.classList.add("is-invalid");
    trackInvalidEnquiryForm(input);
  }
};

function initForm(form, eventHandlers = {}) {
  (function () {
    if (form) {
      form.setAttribute('novalidate', 'novalidate');
      form.addEventListener('submit', function (event) {
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
        }
      }, false);
    }
  })();

  if (form) {
    const EVENT_HANDLERS = {
      input: handleInput,
      blur: { handler: handleBlur, useCapture: true },
      invalid: { handler: handleInvalid, useCapture: true },
      focus: { handler: handleFocus, useCapture: true },
      ...eventHandlers,
    };

    Object.keys(EVENT_HANDLERS)
      .filter(eventName => EVENT_HANDLERS[eventName])
      .forEach(eventName => {
        const event = EVENT_HANDLERS[eventName];
        const handler = event.handler || event;
        const useCapture = !!event.useCapture;

        form.addEventListener(eventName, handler, useCapture);
      });

    form.querySelectorAll(".js-phone-input").forEach(input => {
      input.setAttribute("pattern", PHONE_PATTERN.source);
    });
  }
}

const queryString = (formData = {}) =>
  Object.keys(formData)
    .map(key => `${key}=${encodeURIComponent(formData[key])}`)
    .join("&");

export { initForm as default, queryString };



// WEBPACK FOOTER //
// ./utils/Forms.js